import { apiClient } from './apiClient';

export interface PrimeSelection {
  prime_artifact_id: string;
  company_name: string;
  selected: boolean;
}

export interface ImportNode {
  company_artifact_id: string;
  parent_id?: string;
  prime_selections: PrimeSelection[];
}

export interface PrimeToCompanyImportRequest {
  import_nodes: ImportNode[];
  company_id?: string;
  prime_artifact_ids?: string[];
}

export interface PrimeToCompanyImportResponse {
  company_id?: string;
  artifact_tree_id?: string | null;
  imported_count?: number;
  created_artifacts?: number;
  created_states?: number;
  created_processes?: number;
  // ISSUE-013: Artifacts should include parent_ref and complete artifact_type
  artifacts: Array<{
    id: string;
    company_id?: string;
    name: string;
    description?: string;
    artifact_type?: string;
    artifact_type_id?: string;
    parent_ref?: string | null;
    parent_artifact_id?: string | null;
    prime_artifact_id?: string | null;
    artifact_tree_id?: string;
    created_at?: string;
    updated_at?: string;
    [key: string]: any;
  }>;
  errors?: string[];
}

export class PrimeToCompanyImportService {
  static async importPrimeToCompany(
    request: PrimeToCompanyImportRequest
  ): Promise<PrimeToCompanyImportResponse> {
    try {
      const response = await apiClient.post<PrimeToCompanyImportResponse>(
        '/prime-to-company-import',
        request
      );
      return response.data;
    } catch (error) {
      console.error('Error importing prime to company:', error);
      throw error;
    }
  }
}

export const primeToCompanyImportService = new PrimeToCompanyImportService();
